import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import {
  Button,
  DialogActions,
  DialogContent,
  Stack,
  TextField,
} from '@mui/material';
import ResponsiveDialogActions from './ResponsiveDialogAction';

const getMidnightDate = date => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

const getEndOfDayDate = date => {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
};
const datePickerPopperSx = {
  direction: 'rtl',
  '& .MuiPickersCalendarHeader-labelContainer': {
    marginRight: 0,
    marginLeft: 'auto', // هدایت دکمه‌ها به سمت چپ تقویم
  },
  '& .MuiPickersArrowSwitcher-root': {
    direction: 'rtl',
  },
  '& .MuiPickersArrowSwitcher-root .MuiIconButton-root': {
    transform: 'rotate(180deg)', // چرخش فلش‌ها برای مطابقت با تقویم راست‌چین
  },
  '& .MuiPickersLayout-root': {
    direction: 'rtl',
  },
};

export default function DateRangeDialog({ open, onClose, onConfirm }) {
  const today = getMidnightDate(new Date());
  const thirtyDaysAgo = getMidnightDate(new Date());
  thirtyDaysAgo.setDate(today.getDate() - 30);

  const [fromDate, setFromDate] = React.useState(thirtyDaysAgo);
  const [toDate, setToDate] = React.useState(today);

  const handleConfirm = () => {
    if (fromDate && toDate) {
      onConfirm(fromDate, getEndOfDayDate(toDate));
    }
    onClose();
  };

  // Shared textField styling (unchanged)
  const textFieldSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: '#F8FAFC', // Light subtle background
      minHeight: '52px',
      transition: 'all 0.2s ease-in-out',
      '& fieldset': {
        borderColor: '#E2E8F0', // Clean default border
        borderWidth: '1px',
      },
      '&:hover': {
        backgroundColor: '#F1F5F9',
      },
      '&:hover fieldset': {
        borderColor: '#CBD5E1',
      },
      '&.Mui-focused': {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 0 0 4px rgba(59, 130, 246, 0.12)', // Modern focus ring
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3B82F6',
        borderWidth: '1px',
      },
    },
    // Ensure the label color transitions smoothly
    '& .MuiInputLabel-root': {
      color: '#64748B',
      fontWeight: 500,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#3B82F6',
    },
    // Fixes for autocomplete inner paddings
    '& .MuiAutocomplete-inputRoot': {
      padding: '6px 12px !important',
      gap: '6px',
    },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
      <DialogContent dir="rtl">
        <Stack spacing={3} sx={{ mt: 1 }}>
          <DatePicker
            label="از تاریخ"
            value={fromDate}
            onChange={newValue => setFromDate(newValue)}
            slotProps={{
              textField: {
                fullWidth: true,
                size: 'small',
                sx: textFieldSx,
              },
              popper: { sx: datePickerPopperSx },
            }}
            renderInput={params => (
              <TextField {...params} fullWidth size="small" sx={textFieldSx} />
            )}
          />
          <DatePicker
            label="تا تاریخ"
            value={toDate}
            onChange={newValue => setToDate(newValue)}
            slotProps={{
              textField: {
                fullWidth: true,
                size: 'small',
                sx: textFieldSx,
              },
              popper: { sx: datePickerPopperSx },
            }}
            renderInput={params => (
              <TextField {...params} fullWidth size="small" sx={textFieldSx} />
            )}
          />
        </Stack>

        <ResponsiveDialogActions
          onAccept={handleConfirm}
          onReject={onClose}
          acceptText={'دانلود خروجی'}
          acceptButtonProps={{
            sx: {
              py: 1.2, // Tighter button height
              borderRadius: '12px',
              color: '#fff',
              fontWeight: 700,
              fontSize: '0.95rem',
              letterSpacing: '0.5px',
              boxShadow: '0 6px 16px rgba(16, 185, 129, 0.2)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                boxShadow: '0 8px 20px rgba(16, 185, 129, 0.3)',
              },
              '&:disabled': {
                background: '#CBD5E1',
                color: '#94A3B8',
                boxShadow: 'none',
              },
            },
          }}
          rejectButtonProps={{
            sx: {
              py: 1.2, // Tighter button height
              borderRadius: '12px',
              border: '2px solid transparent',
              color: '#64748B',
              fontWeight: 700,
              fontSize: '0.95rem',
              backgroundColor: '#F1F5F9',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: '#FEE2E2',
                color: '#E11D48',
                transform: 'translateY(-2px)',
              },
            },
          }}
        />
      </DialogContent>
    </LocalizationProvider>
  );
}
